import Header from "./Header";
import Footer from "./Footer";
import CTASection from "./CTASection";
import "../styles/header/header.css";

export default function TermsOfUse() {
  return (
    <div className="main">
      <Header />
      <div
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          padding: "2rem",
          fontSize: "1.1rem",        // increased font size
          lineHeight: "1.75rem",     // improved line spacing
          color: "#222",             // slightly softer black
        }}
      >
        <h1
          style={{
            fontSize: "2.2rem",
            fontWeight: "bold",
            marginBottom: "1.5rem",
            textAlign: "left",
          }}
        >
          Terms of Use
        </h1>

        <p>
          <strong>General</strong>
          <br />
          Thank you for visiting{" "}
          <a href="https://upload.ai.gov.kh/">https://upload.ai.gov.kh/</a>{" "}
          (“website”). This platform is officially operated by the{" "}
          <strong>Ministry of Post and Telecommunications (MPTC)</strong>. By
          accessing or using this website, you agree to comply with and be bound
          by these Terms of Use. If you do not agree, please discontinue access
          and refrain from using this website.
        </p>

        <p>
          MPTC reserves the right to amend or update these Terms of Use at any
          time without prior notice. Any changes will be effective once
          published on this website.
        </p>

        <p>
          <strong>Copyrights and Intellectual Property</strong>
          <br />
          All materials, content, and intellectual property on this website are
          owned, licensed, or controlled by the Ministry of Post and
          Telecommunications (MPTC). No content—including but not limited to
          text, images, software, and files—may be reproduced, distributed,
          modified, or transmitted in any form without the prior written consent
          of MPTC.
        </p>

        <p>
          <strong>Use of Upload Platform</strong>
          <br />
          Users must ensure that any files uploaded through this website:
        </p>
        <ul style={{ paddingLeft: "1.5rem", marginBottom: "1rem" }}>
          <li>Do not contain viruses, malicious code, or harmful content.</li>
          <li>Do not infringe on the intellectual property rights of others.</li>
          <li>
            Do not contain unlawful, offensive, defamatory, or inappropriate
            material.
          </li>
          <li>
            Comply with all applicable laws and regulations of the Kingdom of
            Cambodia.
          </li>
        </ul>
        <p>
          The Ministry of Post and Telecommunications reserves the right to
          monitor, remove, or restrict access to any content that is deemed to
          violate these Terms of Use or national law.
        </p>

        <p>
          <strong>Availability and Right of Access</strong>
          <br />
          The Ministry of Post and Telecommunications may suspend, modify, or
          discontinue the operation of this website at any time without prior
          notice. Access to this website may be restricted or denied to any
          person or IP address without prior notice and without providing
          reasons.
        </p>

        <p>
          The Ministry of Post and Telecommunications does not guarantee
          uninterrupted access, error-free operation, or the security of files
          uploaded by users. Users are responsible for keeping copies of their
          own files.
        </p>

        <p>
          <strong>Links to Other Websites</strong>
          <br />
          This website may contain links to third-party websites. MPTC does not
          endorse, control, or take responsibility for the content,
          functionality, or security of those websites. Accessing third-party
          links is at your own risk.
        </p>

        <p>
          <strong>Disclaimer and Limitation of Liability</strong>
          <br />
          The Ministry of Post and Telecommunications shall not be liable for
          any damages, loss of data, or other harm arising from:
        </p>
        <ul style={{ paddingLeft: "1.5rem", marginBottom: "1rem" }}>
          <li>Use of or inability to use this website.</li>
          <li>Unauthorized access or alterations to your uploaded content.</li>
          <li>
            Reliance on information, services, or links provided by this
            website.
          </li>
        </ul>

        <p>
          <strong>Creating a Link to This Website</strong>
          <br />
          Written permission from the Ministry of Post and Telecommunications is
          required before creating any link to this website or its content.
        </p>

        <p>
          <strong>Governing Law</strong>
          <br />
          These Terms of Use shall be governed by and construed in accordance
          with the laws of the Kingdom of Cambodia.
        </p>
      </div>
      <CTASection />
      <Footer hideFooter={false} />
    </div>
  );
}
